export default __webpack_public_path__ + "static/Plots0013-7476b4f3b11edd9bb6f63bb1aa3fa1e6.jpg";